import { useEffect } from 'react';
import Clarity from '@microsoft/clarity';

export const useClarity = () => {
  useEffect(() => {
    const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;

    if (process.env.NODE_ENV === 'production' && projectId) {
      Clarity.init(projectId);
    }
  }, []);
};
